import { render, staticRenderFns } from "./DocumentNewFormFrProject.vue?vue&type=template&id=5516e94a"
import script from "./DocumentNewFormFrProject.vue?vue&type=script&lang=js"
export * from "./DocumentNewFormFrProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports